import { CCol, CRow } from "@coreui/react"
import { CMSButton } from "components/common/button"
import { Tooltip } from "components/common/tooltip"
import PropTypes from "prop-types"
import React from "react"

export default function FormActions({
  onSubmit,
  onCancel,
  submitText,
  className = "",
  isSubmitDisabled = false,
  colStyling = "",
  tooltipEnabled = false,
  tooltipText
}) {
  return (
    <CRow className={`mx-2 my-4 ${className} `}>
      <CCol md="12" className={`d-flex justify-content-flex-end ${colStyling}`}>
        <CMSButton
          type="primary"
          outline={true}
          onClick={() => onCancel && onCancel()}
          className="mr-4"
        >
          Cancel
        </CMSButton>
        <Tooltip
          disabled={!tooltipEnabled}
          text={tooltipText}
          position="leftTop"
        >
          <CMSButton
            type="primary"
            disabled={isSubmitDisabled}
            dataTestId={"form-submit"}
            onClick={() => onSubmit && onSubmit()}
          >
            {submitText || "Submit"}
          </CMSButton>
        </Tooltip>
      </CCol>
    </CRow>
  )
}

FormActions.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  className: PropTypes.string,
  submitText: PropTypes.string,
  isSubmitDisabled: PropTypes.bool,
  colStyling: PropTypes.string,
  tooltipEnabled: PropTypes.bool,
  tooltipText: PropTypes.string
}
